module.exports = __webpack_public_path__ + "img/logo-installment-visa-master-card.297c061b.png";